export default "__VITE_ASSET__C2jI0Ccg__"